import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LCLShipmentModel } from '@data-layer/models/lcl';
import { enumLclTrackingStates } from '@enum/enumLclTrackingStates';
import { enumShippingRole } from '@data-layer/enums/user';

@Component({
  selector: 'app-lcl-destination-warehouse',
  templateUrl: './lcl-destination-warehouse.component.html',
  styleUrls: ['./lcl-destination-warehouse.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclDestinationWarehouseComponent {
  @Input() public shipment: LCLShipmentModel;
  public TRACKING_STATES: typeof enumLclTrackingStates = enumLclTrackingStates;

  constructor() {}

  public get isImporter(): boolean {
    return this.shipment.shippingRole === enumShippingRole.IMPORTER;
  }

  public get isHasContactsInfo(): boolean {
    return (
      !!this.shipment?.voyage?.destinationContainerFreightStorage?.phoneNumber ||
      !!this.shipment?.voyage?.destinationContainerFreightStorage?.faxNumber ||
      !!this.shipment?.voyage?.destinationContainerFreightStorage?.email
    );
  }
}
